module.exports = __webpack_public_path__ + "static/media/logo-visitmodena-small.7f25d440.svg";